import {Pipe, PipeTransform} from "@angular/core";


@Pipe({name: 'keysBack'})
export class KeysBackPipe implements PipeTransform {
  transform(value, args:string[]) : any {
    let keys = [];
    for (let key in value) {
      let replace = {};

      for(let i in value[key]){
        replace[i] = value[key][i];
      }
      keys.push({key: key, replace: replace});
    }
    return keys;
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/pipes/keys-back.pipe.ts